import React, { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthProvider } from '@ryanar/react-auth-provider';
import routePaths from 'routes/routePaths';
import accountsStore from 'store/accountsStore';
import auth from 'utils/auth';
import noop from 'utils/noop';

interface IAppProviderProps {
  children: ReactNode;
}

// Could be extended if more providers needed
const AppProvider = ({ children }: IAppProviderProps) => {
  const history = useHistory();

  // Temp handlers, local storage token handle must be implemented
  const handleLogin = noop;

  const handleLogout = () => {
    auth.logout();
    history.push(routePaths.login);
    accountsStore.resetAccounts();
  };

  return (
    <AuthProvider onLogin={handleLogin} onLogout={handleLogout}>
      { children }
    </AuthProvider>
  );
};

export default (AppProvider);
